import {
  AccordionDetails as MUIAccordionDetails,
  AccordionDetailsProps as MUIAccordionDetailsProps,
} from '@mui/material';
import Spinner from '../../../../animations/Spinner';
import { mergeSX } from '../../../../services/helpers';

export interface IAccordionDetailsProps extends MUIAccordionDetailsProps {
  isLoading?: boolean;
}

interface IBuildSXParams {
  isLoading: boolean;
}

const buildSX = ({ isLoading }: IBuildSXParams) => ({
  '&.MuiAccordionDetails-root': {
    textAlign: isLoading ? 'center' : 'initial',
  },
});

const AccordionDetails = (props: IAccordionDetailsProps) => {
  const {
    children, isLoading = false, sx, ...restProps
  } = props;

  return (
    <MUIAccordionDetails
      sx={mergeSX(buildSX({ isLoading }), sx)}
      {...restProps}
    >
      {isLoading ? <Spinner /> : children}
    </MUIAccordionDetails>
  );
};

export default AccordionDetails;
